import React from 'react';
import ErrorPage from '.';

const Error404 = (...rest) => {
  return <ErrorPage errorCode={404} title="Page not found" {...rest} />;
};

export default Error404;
